export const campaignTypeOptions = [
	{ id: 0, description: 'Standardní' },
	{ id: 3, description: 'Dožití' },
];
